import { render, staticRenderFns } from "./ticketOnTimeStatistics.vue?vue&type=template&id=2d52bcc8&scoped=true&"
import script from "./ticketOnTimeStatistics.vue?vue&type=script&lang=js&"
export * from "./ticketOnTimeStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d52bcc8",
  null
  
)

export default component.exports